import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-05632858"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "start-screen" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  style: {"display":"flex","flex-direction":"column","justify-content":"center","align-items":"flex-start"}
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"font-size":"small"} }, "Finde dein Lieblingsprodukt in", -1))
const _hoisted_6 = { class: "desktop" }
const _hoisted_7 = { class: "action" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

import { PropType, computed } from 'vue'
import Company from '@/entities/domain/Company/Company';
import ChatbotIcon from '@/components/Elements/Chatbot/ChatbotIcon.vue';
import getImageFromSource from '@/utils/getImageFromSouce';
import Close from '@/components/svg/Close.vue';
import Arrow from '@/components/svg/Arrow.vue';
import Location from '@/components/svg/Location.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FirstLevelSupport',
  props: {
    company: {
        type: Object as PropType<Company>,
        required: true,
    },
    avatar: {
        type: String,
        required: true,
    }
},
  emits: ['close', 'open', 'startSupportChat'],
  setup(__props, { emit: __emit }) {

const emits = __emit;


const props = __props

const brandLogoImageSource = computed(() => {
    return getImageFromSource(
        props.company?.FrontendDesign?.BrandLogoImage ??
        "@/assets/img/logo_tailorproduct.svg"
    );
})

const open = (url: string) => {
    window.open(url, '_blank');
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (!__props.company.CompanyQuizConfig.DemoLocation)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: brandLogoImageSource.value
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (open('https://www.jacques.de/weindepots'))),
              style: {"color":"var(--wizard-primary-color)","cursor":"pointer","display":"flex","gap":".2em","justify-content":"center","align-items":"center"}
            }, [
              _createVNode(Location, {
                color: __props.company.FrontendDesign?.ProductWizard?.PrimaryColor
              }, null, 8, ["color"]),
              _createTextVNode(_toDisplayString(__props.company.CompanyQuizConfig.DemoLocation), 1),
              _createVNode(Arrow, {
                color: __props.company.FrontendDesign?.ProductWizard?.PrimaryColor,
                style: {"rotate":"90deg"}
              }, null, 8, ["color"])
            ])
          ])),
      (!props.company.CompanyQuizConfig.FullscreenMode)
        ? (_openBlock(), _createBlock(Close, {
            key: 2,
            class: "close",
            fill: __props.company.FrontendDesign?.ProductWizard?.FontColorSecondary,
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emits('close')))
          }, null, 8, ["fill"]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["primary-action", { noRadius: props.company.DisplayedTexts['border_radius'] === 'false' }])
    }, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(ChatbotIcon, {
            avatar: __props.avatar,
            "show-online-indicator": true,
            "hover-effect": false,
            "border-active": props.company.FrontendDesign?.ProductWizard?.TextConventions?.showIconBorder === 'true',
            "background-color": __props.company.FrontendDesign?.ProductWizard?.IconBackgroundColor ?? __props.company.FrontendDesign?.ProductWizard?.PrimaryColor,
            size: 8
          }, null, 8, ["avatar", "border-active", "background-color"]),
          _createElementVNode("div", {
            class: "info",
            style: _normalizeStyle({ fontSize: props.company.FrontendDesign?.ProductWizard?.TextConventions?.primaryFontSize })
          }, [
            _createTextVNode(_toDisplayString(props.company.FrontendDesign?.ProductWizard?.TextConventions!["Hallo & herzlich Willkommen!"]) + " ", 1),
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(__props.company.DisplayedTexts["Wie kann ich dir helfen?"]), 1)
          ], 4),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = ($event: any) => (emits('open')))
          }, _toDisplayString(__props.company.DisplayedTexts["Digitale Produktberatung"]), 1),
          _createElementVNode("button", {
            class: "secondary",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emits('startSupportChat')))
          }, _toDisplayString(__props.company.DisplayedTexts["Kundenservice kontaktieren"]), 1)
        ])
      ])
    ], 2)
  ]))
}
}

})